import React from 'react';
import { makeStyles } from '@material-ui/styles';
import FailedSavesBar from 'components/SaveStatus/FailedSavesBar';
import UnsavedChangesBar from 'components/UnsavedChanges';

const useStyles = makeStyles(() => ({
    // Floating under the top bar, wherever the page is scrolled; only the
    // notices themselves take a click.
    root: {
        position: 'fixed',
        top: 72,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1400,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        gap: 8,
        width: 'max-content',
        maxWidth: 'calc(100vw - 32px)',
        pointerEvents: 'none',
    },
}));

/**
 * THE WINDOW'S WARNINGS, one above the other (3 Nov 2026): what did not get
 * in (red), then what is changed and not saved (orange). Mounted once, in App.
 */
const TopNotices = () => {
    const classes = useStyles();
    // Not over a hall screen or the mat phone's sheet — the phone says what
    // did not get in on its own bottom line (3 Nov 2026).
    if (/^\/(display|mat-phone)(\/|$)/.test(window.location.pathname)) {
        return null;
    }

    return (
        <div className={classes.root}>
            <FailedSavesBar />
            <UnsavedChangesBar />
        </div>
    );
};

export default TopNotices;
